import { useTranslation } from 'react-i18next';
import { Box } from '@mui/system';
import AddMembersToGroupForm from 'components/forms/MessagingFactory/AddMembersToGroupForm';
import { ModalBase } from 'remote/global';

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

function AddMembersToGroupModal({ open, setOpen, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <ModalBase
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      maxWidth='md'
      title={t('modals.addMembersToGroup.title').toString()}
      description={t('modals.addMembersToGroup.subtitle').toString()}
      fullWidth
    >
      <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
        <AddMembersToGroupForm onClose={onClose} />
      </Box>
    </ModalBase>
  );
}
export default AddMembersToGroupModal;
